import Vue from 'vue'
import Vuex from 'vuex'
import * as Settings from './settings'

// == filters
import {FilterDateRange} from './filters/FilterDateRange.js'
import {FilterLocations} from './filters/FilterLocations.js'
import {FilterMapActive} from './filters/FilterMapActive.js'
import {FilterMapBounds} from './filters/FilterMapBounds.js'

import {LocationsCollisions} from './modules/LocationsCollisions.js'

// == views
import {CityCouncilDistrictView} from './views/CityCouncilDistrictView.js'
import {CityCouncilDistrictsView} from './views/CityCouncilDistrictsView.js'
import {CityCouncilDistrictRanksView} from './views/CityCouncilDistrictRanksView.js'
import {CollisionsView} from './views/CollisionsView.js'
import {LocationsView} from './views/LocationsView.js'
import {NeighborhoodView} from './views/NeighborhoodView.js'
import {NeighborhoodsView} from './views/NeighborhoodsView.js'
import {NeighborhoodRanksView} from './views/NeighborhoodRanksView.js'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    filterDateRange: FilterDateRange,
    filterLocations: FilterLocations,
    filterMapActive: FilterMapActive,
    filterMapBounds: FilterMapBounds,
    locationsCollisions: LocationsCollisions,

    // == views
    cityCouncilDistrictView: CityCouncilDistrictView,
    cityCouncilDistrictsView: CityCouncilDistrictsView,
    cityCouncilDistrictRanksView: CityCouncilDistrictRanksView,
    collisionsView: CollisionsView,
    locationsView: LocationsView,
    neighborhoodView: NeighborhoodView,
    neighborhoodsView: NeighborhoodsView,
    neighborhoodRanksView: NeighborhoodRanksView
  },

  state: {},

  mutations: {},

  actions: {},

  getters: {
    chartColors: state => {
      return Settings.chartColors
    },

    black: state => {
      return Settings.black
    },

    blue: state => {
      return Settings.blue
    },

    brown: state => {
      return Settings.brown
    },

    green: state => {
      return Settings.green
    },

    orange: state => {
      return Settings.orange
    },

    pink: state => {
      return Settings.pink
    },

    purple: state => {
      return Settings.purple
    },

    red: state => {
      return Settings.red
    },

    teal: state => {
      return Settings.teal
    },

    yellow: state => {
      return Settings.yellow
    }
  }
})



// WEBPACK FOOTER //
// ./src/vuex/store.js